import { Component, OnInit, ViewChild } from '@angular/core';
import { AccountService } from '../../accounts.service';
import { HttpClient } from '@angular/common/http';
import { SharedService } from '../../../../../shared/shared.service';
import { AccountArry } from './account';
import { Location } from '@angular/common';
import { UsefulToolsService } from '../../../../../shared/other/usefultools.service';
import { Router } from '@angular/router';
import { TripService } from '../../../trips/trips-main/trip.services';
import { DxDataGridModule, DxDataGridComponent } from "devextreme-angular";
import { InvoiceService } from '../../invoices.service';

@Component({
  selector: 'app-accounts-edit',
  templateUrl: './accounts-edit.component.html',
  styleUrls: ['./accounts-edit.component.css']
})
export class AccountsEditComponent implements OnInit {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  popupVisible = false;
  dataSource: any;
  dataSource2: any;
  sessionId = sessionStorage.getItem('com-session-id');
  accountId = sessionStorage.getItem('account-id');

  constructor(
    public account: AccountService,
    private httpClient: HttpClient,
    public sharedService: SharedService,
    private location: Location,
    public sharedservice: SharedService,
    private usefultoolsservice: UsefulToolsService,
    private router: Router,
    private tripservice: TripService,
    public invoice: InvoiceService
  ) { }

  formatDateString = this.sharedservice.dateFormatString;

  ngOnInit() {
    this.sharedService.loadingActive = true;
    if (this.account.account === undefined) {
      this.location.back();
    } else {
      if (this.account.account === 1) {
        // tslint:disable-next-line:max-line-length
        this.dataSource = { NAME: '', EMAIL: '', CONTACTNUMBER: '', VATNUMBER: '', BILLINGADDESS: '' };
        this.sharedService.loadingActive = false;
      } else {
        // tslint:disable-next-line:max-line-length
        this.httpClient.get<any>(`${this.sharedService.URL}/dbTabAccount?SessionID=${this.sessionId}&ID=${this.accountId}`).subscribe(Response => {
          this.dataSource = Response.dbTabAccount_response.view[0];

          const postThis = {
            SessionID: this.sessionId,
            ID: 'TripsByAccount',
            parameters:
            [
              {
                value: this.accountId
              }
            ]
          };
          this.httpClient.post<any>(`${this.sharedservice.URL}/utData`, postThis).subscribe(Response2 => {
            console.log(Response2.utData_response);
            if(Response2.utData_response !== null){
              this.dataSource2 = Response2.utData_response.list;
              this.dataSource2.forEach(element => {
                // this.httpClient.get<any>(`${this.sharedservice.URL}/dbTripExpense?SessionID=${sessionStorage.getItem('com-session-id')}&Search=${element.ID}`).subscribe(Response3 => {
                //   console.log(Response3);
                //   if(Response3 != null){
                //     const tempExp = Response3.dbTripExpense_response.view;
                //     let sum = 0;
                //     this.sharedService.loadingActive = false;
                //     if (Response3.dbTripExpense_response.view === null) {
                //       element.totalCost = 0
                //     } else {
                //       tempExp.forEach(element1 => {
                //         sum += element1.AMOUNT;
                //       });
                //       element.totalCost = sum;
                //     }
                //   } else {
                    let sum = 0;
                //   }
                // });
              });
            } else {
              this.sharedService.loadingActive = false;
            }
            this.sharedService.loadingActive = false;
          });
        });
      }
    }
  }

  onFormSubmit() {

    // validation
    if (this.dataSource.NAME === '' || this.dataSource.NAME === null) {
      this.usefultoolsservice.notify('error', `Required name`);
      return;
    }
    // email correct format
    if (this.dataSource.EMAIL !== '') {
      if (this.validateEmail(this.dataSource.EMAIL) != true) {
        this.usefultoolsservice.notify('error', `Email not valid`);
        return;
      }
    }
    if (this.dataSource.CONTACTNUMBER === '' || this.dataSource.CONTACTNUMBER === null) {
      this.usefultoolsservice.notify('error', `Required contact number`);
      return;
    }
    if (isNaN(this.dataSource.CONTACTNUMBER) === true) {
      this.usefultoolsservice.notify('error', `Contact number must be numeric`);
      return;
    }

    const postThis = {
      SessionID: sessionStorage.getItem('com-session-id'),
      TabAccount: [this.dataSource]
    }

    if (this.account.account === 1) {
      this.httpClient.post<any>(`${this.sharedService.URL}/dbTabAccount?SessionID=${this.sessionId}`, postThis).subscribe(Response => {
        if (Response.dbTabAccount_response.ServiceResults[0].RESULTDESCRIPTION === 'success' && Response.dbTabAccount_response.ServiceResults[0].RESULTACTION === 'insert') {
          this.usefultoolsservice.notify('success', this.sharedservice.notificationMessages.successUpdate);
          this.location.back();
        } else {
          this.usefultoolsservice.notify('error', `Error: ${Response.dbTabAccount_response.ServiceResults[0].ERRORDESCRIPTION}`);
        }
      });
    } else {
      this.httpClient.put<any>(`${this.sharedService.URL}/dbTabAccount?SessionID=${this.sessionId}`, postThis).subscribe(Response => {
        console.log(Response);
        if (Response.dbTabAccount_response.ServiceResults[0].RESULTDESCRIPTION === 'success' && Response.dbTabAccount_response.ServiceResults[0].RESULTACTION === 'updateinsert') {
          this.usefultoolsservice.notify('success', this.sharedservice.notificationMessages.successUpdate);
          this.location.back();
        } else {
          this.usefultoolsservice.notify('error', `Error: ${Response.dbTabAccount_response.ServiceResults[0].ERRORDESCRIPTION}`);
        }
      });
    }
  }

  validateEmail(email) {
    const re = /[a-z0-9!#$%&'*+/=?^_\`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_\`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
    return re.test(email);
  }

  delete() {
    // tslint:disable-next-line:max-line-length
    this.httpClient.delete<any>(`${this.sharedService.URL}/dbTabAccount?SessionID=${this.sessionId}&ID=${this.accountId}`).subscribe(response => {
      this.usefultoolsservice.notify('success', this.sharedService.notificationMessages.successDelete);
      this.location.back();
    });
  }

  routeToTripEdit(pID) {
    sessionStorage.setItem('trips-id', pID);
    this.tripservice.setTrip(1);
    this.router.navigate(['/home/trips/trips-edit']);
  }

  toggle(data) {
    if (data === true) {
      this.popupVisible = true;
    } else {
      this.popupVisible = false;
    }
  }

  getSelectedRowKeys () {
      return this.dataGrid.instance.getSelectedRowKeys();
  }
  getSelectedRowsData () {
  
      console.log(this.dataGrid.instance.getSelectedRowsData());
      let x = this.dataGrid.instance.getSelectedRowsData();

      const postThis = {
        SessionID: sessionStorage.getItem('com-session-id'),
        Trips: x
      } 
      this.httpClient.post<any>(`${this.sharedService.URL}/utCreateInvoice`, postThis).subscribe(Response => {
        console.log(Response);
        // rerout to invoice screen
        sessionStorage.setItem('invoice-id', Response.utCreateInvoice_response.invoiceid);
        this.invoice.setInvoice(0);
        this.router.navigate(['/home/operations/invoices/invoices-edit']);
      });
    }
}
